export default "__VITE_ASSET__BrFH6apF__"